var galleryThumbs = new Swiper('.gallery-thumbs', {
	spaceBetween: 0,
	slidesPerView: 4,
	freeMode: true,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
});

var galleryTop = new Swiper('.gallery-top', {
	spaceBetween: 5,
	autoHeight: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	thumbs: {
		swiper: galleryThumbs
	}
});


// Get slider element
const slider = document.querySelector('.swiper-parent-container');

// Listen for transition end event
slider.addEventListener('transitionend', setLayout);

setLayout();

function setLayout() {
	const slides = document.querySelectorAll('.gallery-top .swiper-slide');
	let layout = ''; // Initialize the layout variable outside the loop

	for (let i = 0; i < slides.length; i++) {
		const slide = slides[i];

		if (slide.classList.contains('swiper-slide-active')) {
		layout = slide.getAttribute('data-layout'); // Store the layout value in the variable
		break;
		}
	}

	const parentElement = slider.parentElement;

	// Remove existing 'vertical' or 'horizontal' classes before adding the new one
	parentElement.classList.remove('vertical', 'horizontal');

	// Add the layout value as a class to the parent element of the slider
	parentElement.classList.add(layout);
}
